import { removeBlankAttributes } from '../../utils'
import apiInstance from '../../utils/apiInstance'
import { toCamelCase } from '../../utils/functions'

const baseURLs = {
  SSOService: window.SSOService,
  core: window.core,
  chatbot: window.chatbot,
  consumer: window.consumer,
  docService: window.docService,
}

export const getRequestAsync = async (apiEndPoint, module = 'core', headers, skipSuccess) => {
  try {
    const response = await apiInstance.get(`${baseURLs[module]}${apiEndPoint}`, {
      headers: {
        ...headers,
        customHeader: true,
      },
    })
    if (skipSuccess) {
      return true
    }
    if (response.status === 200 && response.data.success) {
      return response.data && toCamelCase(response.data.data)
    }
    throw response.data
  } catch (e) {
    if (e.response && e.response.data) {
      const error = {
        data: {},
        msg: e.response.data.message || 'Something went wrong !',
      }
      throw error
    }
    if (!e.message) {
      e.data = {}
      e.msg = 'Something went wrong !'
      throw e
    } else {
      e.msg = e.message
    }
    throw e
  }
}

export const postRequestAsync = async (apiEndPoint, body, module = 'core', headers, sendCompleteResponse) => {
  try {
    const response = await apiInstance.post(
      `${baseURLs[module]}${apiEndPoint}`,
      body && !(body instanceof FormData) ? removeBlankAttributes(body) : body,
      {
        headers: {
          ...headers,
          customHeader: true,
        },
      }
    )
    if (response.status === 200 && response.data.success) {
      if (sendCompleteResponse) {
        return toCamelCase(response.data)
      }
      return response.data && toCamelCase(response.data.data)
    }
    throw response.data
  } catch (e) {
    if (e.response && e.response.data) {
      const error = {
        data: {},
        msg: e.response.data.message || 'Something went wrong !',
      }
      throw error
    }
    if (!e.message) {
      e.data = {}
      e.msg = e.msg || 'Something went wrong !'
      throw e
    } else {
      e.msg = e.message
    }
    throw e
  }
}
